import React from 'react'
function detailCustomer(){
    return(
        <div className='container'>
            Detail
        </div>
    )
}
export default detailCustomer;